// Round 3 lane 1 copy (10/16/26): listing times, Saved dates, remove from Saved, typed dates (R-98, R-106, R-104, R-102).
// Opus draft, Astra pass pending: Astra had not drafted these when the lane shipped (AGENTS.md "Copy and UI": if Astra is
// unavailable, Opus covers). A line that needs to change goes back to Astra. Its own file so the lane merges cleanly.
export const R3T = {
  // R-98 (B-137): a weekly night at a venue shows its own day, not the venue's opening hours
  'r3t.every_day': 'Every {days}',
  'r3t.every_day_time': 'Every {days} · {time}',
  'r3t.check_time': 'Check the time on their page',
  'r3t.venue_hours': 'Venue hours',
  // R-98 (B-115): a show whose stored time looks wrong shows its day only
  'r3t.time_unclear': 'Check the time',
  // R-106 (B-117): Saved shows the next real date
  'r3t.next': 'Next: {day}',
  'r3t.next_time': 'Next: {day} · {time}',
  'r3t.no_upcoming': 'No upcoming date',
  'r3t.no_upcoming_last': 'No upcoming date (last was {day})',
  // R-104 (B-167): remove from Saved, with undo
  'r3t.remove': 'Remove',
  'r3t.removed': 'Removed {title} from Saved.',
  'r3t.undo': 'Undo',
  'r3t.remove_error': 'Could not remove it. Try again.',
  // R-102 (B-172): typed dates on desktop
  'r3t.date_hint': 'MM/DD/YYYY',
  'r3t.date_bad': 'Type a date like 10/24/2026.',
  'r3t.date_past': 'Pick today or a later date.',
  'r3t.date_order': 'The end date is before the start date.',
} as const

export type R3tKey = keyof typeof R3T
/** A Round 3 lane 1 line, with {placeholders} filled. */
export const r3t = (k: R3tKey, vars: Record<string, string | number> = {}): string =>
  R3T[k].replace(/\{(\w+)\}/g, (m, name: string) => (name in vars ? String(vars[name]) : m))

/** "Wednesday", "Tuesdays and Thursdays"... the weekday names a weekly line uses (Opus draft, Astra pass). */
const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
const DAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
export function weekdaysText(days: number[]): string {
  const d = [...days].sort((a, b) => a - b)
  if (d.length === 1) return DAY_NAMES[d[0]]
  if (d.length === 2) return `${DAY_NAMES[d[0]]} and ${DAY_NAMES[d[1]]}`
  return d.map((x) => DAY_SHORT[x]).join(', ')
}
